import type { MonthInsight } from '../../../../entities/summary/index.js';
import { List, ListItem } from '../../../../shared/ui/index.js';
import {
  forecastLineOf,
  isInsightEmpty,
  monthLineTitleOf,
  usualLineOf,
} from '../../lib/month-insight-text.js';

type CurrentMonthLineProps = {
  insight: MonthInsight;
  onOpen: () => void;
};

export const CurrentMonthLine = ({ insight, onOpen }: CurrentMonthLineProps) => {
  if (isInsightEmpty(insight)) {
    return null;
  }

  return (
    <List>
      <ListItem
        title={monthLineTitleOf(insight)}
        isTitleWrapping
        subtitle={forecastLineOf(insight) ?? usualLineOf(insight) ?? undefined}
        isSecondLineWrapping
        chevron
        onClick={onOpen}
      />
    </List>
  );
};
